import { z } from 'zod';

export const companyFormSchema = z.object({
  first_name: z.string().trim().min(1, 'First name is required'),
  last_name: z.string().trim().min(1, 'Last name is required'),
  company_name: z.string().trim().min(1, 'Company name is required'),
  company_slug: z.string().trim().min(1, 'Company slug is required'),
  company_registration: z
    .string()
    .trim()
    .min(1, 'Company registration is required'),
  registration_comments: z.string().optional(),
  mobile: z.string().optional(),
  email: z.string().email('Valid email is required'),
  contact: z
    .string()
    .trim()
    .regex(/^[0-9+\-\s()]{8,}$/, 'Valid phone number is required')
});

export type CompanyFormT = z.infer<typeof companyFormSchema>;

export const companyFormDefaultValues: CompanyFormT = {
  first_name: '',
  last_name: '',
  company_name: '',
  company_slug: '',
  company_registration: '',
  registration_comments: '',
  mobile: '',
  email: '',
  contact: ''
};
